import { combineReducers } from "redux";

// import users from "./users";
import login from "./loginReducer";

export default combineReducers({ login });
